import { render } from "./HistoricoSoportesRegistro.vue?vue&type=template&id=2e7e105c"
import script from "./HistoricoSoportesRegistro.vue?vue&type=script&lang=js"
export * from "./HistoricoSoportesRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__